import styled from 'styled-components';

import { formInputMixin } from 'core/ui/mixins';

const Textarea = styled.textarea`
  ${formInputMixin}
`;

export default Textarea;
